// Reveal on scroll
  const obs = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('v'); });
  }, { threshold: 0.08 });
  document.querySelectorAll('.r').forEach(el => obs.observe(el));


  // Pills
  document.querySelectorAll('.pill').forEach(pill => {
    pill.addEventListener('click', function(e) {
      e.preventDefault();
      document.querySelectorAll('.pill').forEach(p => p.classList.remove('active'));
      this.classList.add('active');
    });
  });
